/**
 * Checks for the presence of a variable. Useful for refining maybe types.
 */
export function check(ref) {
  if (!ref) throw new Error('You thought it was there, but it wasn\'t.')
  return ref
}
